// extracted by mini-css-extract-plugin
export default {"skeleton":"skeletonCell_skeleton__Td4VU"};